import { registerPageInit } from '../barba/page-init-registry';
import { initClusterCardSliders } from '../utils/init-cluster-about-operating-widgets';
import '../../css/_root.scss';
import '../../css/pages/infrastructure/infrastructure.scss';
import '../../css/templates/infrastructure-header.scss';

const ROOT_SELECTOR = '[data-barba-namespace="infrastructure"]';

function initInfrastructureTabs(root: HTMLElement): void {
  const tabButtons = root.querySelectorAll<HTMLButtonElement>('[data-infrastructure-tab]');
  const panels = root.querySelectorAll<HTMLElement>('[data-infrastructure-panel]');

  if (!tabButtons.length || !panels.length) return;

  const getInitialTabId = (): string | undefined => {
    const markedActive = root.querySelector<HTMLButtonElement>(
      '[data-infrastructure-tab].active, [data-infrastructure-tab][aria-selected="true"]',
    );
    const fromMarkup = markedActive?.dataset.infrastructureTab?.trim();
    if (fromMarkup) return fromMarkup;

    return tabButtons[0]?.dataset.infrastructureTab?.trim();
  };

  const setActiveTab = (activeIndex: string): void => {
    tabButtons.forEach((button) => {
      const isActive = button.dataset.infrastructureTab === activeIndex;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');

      if (isActive) {
        button.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest',
        });
      }
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.infrastructurePanel === activeIndex;
      panel.classList.toggle('hidden', !isActive);
    });
  };

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const index = button.dataset.infrastructureTab;
      if (index === undefined) return;
      setActiveTab(index);
    });
  });

  const initialTabId = getInitialTabId();
  if (initialTabId !== undefined) {
    setActiveTab(initialTabId);
  }
}

registerPageInit('infrastructure', () => {
  const root = document.querySelector<HTMLElement>(ROOT_SELECTOR);
  if (!root) return;
  initInfrastructureTabs(root);
  initClusterCardSliders(root);
});
